import {importProfile} from "./match-profile";

export function importCandidate(candidate) {
    return {
        ...candidate,
        matchProfile: importProfile(candidate.matchProfile),
    };
}
